import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { BaseComponent, ViispTicketResponse } from '@ridango/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { NotificationFacade } from '@ridango/components';

@Component({
    selector: 'rwidget-signup-viisp-form',
    templateUrl: './signup-viisp-form.component.html'
})
export class SignupViispFormComponent extends BaseComponent implements OnInit, OnDestroy {
    ticketResponse: ViispTicketResponse = null;
    ticketError = false;

    constructor(
        private client: HttpClient,
        @Inject('ENV') private env,
        private translate: TranslateService,
        private notifications: NotificationFacade
    ) {
        super();
    }

    ngOnInit(): void {
        this.notifications.removeAll();
        const url = `${this.env.API_GATEWAY_URL}/identity/v1/viisp/auth/ticket`;
        const returnUrl = `${this.env.PAYMENT_RETURN_URL}${this.translate.currentLang}/viisp`;
        this.client
            .post<ViispTicketResponse>(url, {
                returnUrl: returnUrl
            })
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(
                (response) => {
                    this.ticketResponse = response;
                },
                () => {
                    this.ticketError = true;
                    this.notifications.error(this.translate.instant('VIISP_TICKET_LOAD_FAILED'));
                }
            );
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
